import { formatEuro } from '../../utils/helpers';

export const fmt = (n) => (typeof n === 'number' ? formatEuro(n, 0) : '–');
